import { AiOutlineExclamationCircle } from "react-icons/ai";
import { Icon } from '@chakra-ui/react';

export const TimelineErrorIcon = () => (
<Icon fontSize="lg"  color="red.focusRing">
                            <AiOutlineExclamationCircle />
                        </Icon>
                        )